export interface Oauth {
  Id: number;
  acode: number;
  Platform: number;
  PId: string;
  Email: string;
  Note: string;
  CreateTime: number;
  UpdateTime: number;
}

export interface OauthLoginResult {
  Flag: boolean;
  Message: number;
  Email?: string;
  FirstName?: string;
  LastName?: string;
  PId?: string;
  Platform?: number;
  app?: string;
  time?: number;
  uid?: string;
}

export interface OauthLoginParam {
  LoginType?: number;
  Platform: number;
  PId: string;
  Email: string;
  WithDevice: boolean;
  Code: string;
  IP?: string;
  FirstName?: string;
  LastName?: string;
  Purpose: number;
  app?: string;
  time?: number;
  uid?: string;
}

export interface AccountOauthParam {
  Id?: number;
  otp?: string;
  Platform?: number;
  PId?: string;
  Email?: string;
  Country?: string;
  Code: string;
  FirstName?: string;
  LastName?: string;
  RegisterSys?: number;
  RegisterType?: number;
  UpdateType?: string;
  Purpose?: number;
  app?: string;
  time?: number;
  uid?: string;
  RegionId?: number;
  MSPRegionId?: number;
}

export interface OauthExchangeParam {
  Purpose: number;
  Code?: string;
  Access_token?: string;
  Redirect_Url?: string;
  JWT?: string;
  app?: string;
  time?: number;
  uid?: string;
}
export interface AccountOauthSWParam {
  UId: string;
  Platform: number;
  PId: string;
  SW: string;
  ExpiredTimeStamp: number;
  Email: string;
}
